import { render, staticRenderFns } from "./UserDetails_Button_Follow.vue?vue&type=template&id=99542ae6&scoped=true&"
import script from "./UserDetails_Button_Follow.vue?vue&type=script&lang=js&"
export * from "./UserDetails_Button_Follow.vue?vue&type=script&lang=js&"
import style0 from "./UserDetails_Button_Follow.vue?vue&type=style&index=0&id=99542ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99542ae6",
  null
  
)

export default component.exports